import { i18n, inject, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { CreditCardUpgradeStore } from "./CreditCardUpgradeStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: CreditCardUpgradeStore;
}

@inject("externalInterfaceStore")
@observer
export class CreditCardUpgradeSuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                useWebVersion
                variant="success"
                title={ui.__("creditCardUpgrade.success.title", { productName: this.props.store.upgradeDetails?.offer?.product })}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess("creditCardPurchase")}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/creditCardUpgrade/CreditCardUpgradeSuccess.tsx